import ActionTypes from "../inc/ActionsTypes";

const defaultState = {
    types:[]
}
const ContactTypesReducer = (state = defaultState, actions) =>{
    if(actions.type === ActionTypes.SET_ALL_CONTACT_TYPE){
        state = {
            ...state,
            types:actions.payload
        }
    }
    return state;
}
export default ContactTypesReducer;